// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBalanceAdjustmentTrackingResponseDto
 */
export interface IBalanceAdjustmentTrackingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentTrackingResponseDto
     */
    balance_adjustment_request_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentTrackingResponseDto
     */
    processing_status?: IBalanceAdjustmentTrackingResponseDtoProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentTrackingResponseDto
     */
    raw_data?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IBalanceAdjustmentTrackingResponseDto
     */
    errors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentTrackingResponseDto
     */
    workflow_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof IBalanceAdjustmentTrackingResponseDto
     */
    created_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IBalanceAdjustmentTrackingResponseDtoProcessingStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}


/**
 * Check if a given object implements the IBalanceAdjustmentTrackingResponseDto interface.
 */
export function instanceOfIBalanceAdjustmentTrackingResponseDto(value: object): value is IBalanceAdjustmentTrackingResponseDto {
    return true;
}

export function IBalanceAdjustmentTrackingResponseDtoFromJSON(json: any): IBalanceAdjustmentTrackingResponseDto {
    return IBalanceAdjustmentTrackingResponseDtoFromJSONTyped(json, false);
}

export function IBalanceAdjustmentTrackingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBalanceAdjustmentTrackingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'balance_adjustment_request_id': json['balance_adjustment_request_id'] == null ? undefined : json['balance_adjustment_request_id'],
        'processing_status': json['processing_status'] == null ? undefined : json['processing_status'],
        'raw_data': json['raw_data'] == null ? undefined : json['raw_data'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'workflow_id': json['workflow_id'] == null ? undefined : json['workflow_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IBalanceAdjustmentTrackingResponseDtoToJSON(json: any): IBalanceAdjustmentTrackingResponseDto {
    return IBalanceAdjustmentTrackingResponseDtoToJSONTyped(json, false);
}

export function IBalanceAdjustmentTrackingResponseDtoToJSONTyped(value?: IBalanceAdjustmentTrackingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance_adjustment_request_id': value['balance_adjustment_request_id'],
        'processing_status': value['processing_status'],
        'raw_data': value['raw_data'],
        'errors': value['errors'],
        'workflow_id': value['workflow_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

